import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "../i18n";

import { ENABLE_PT } from "../config";

const validLanguages = ENABLE_PT ? ["en", "pt"] : ["en"];

export const Route = createFileRoute("/$lang")({
  beforeLoad: ({ params, location }) => {
    if (!validLanguages.includes(params.lang)) {
      let lang = "en";
      if (typeof window !== "undefined") {
        const savedLang = localStorage.getItem("bizu-lang");
        if (savedLang) {
          lang = savedLang;
        } else {
          const browserLanguage = navigator.language;
          if (ENABLE_PT && browserLanguage && browserLanguage.startsWith("pt")) {
            lang = "pt";
          }
          localStorage.setItem("bizu-lang", lang);
        }
      }

      const parts = location.pathname.split("/").filter(Boolean);
      const firstSegment = parts[0];

      let targetPath = "";
      if (firstSegment && firstSegment.length === 2 && firstSegment !== "en" && (ENABLE_PT ? firstSegment !== "pt" : true)) {
        targetPath = `/${lang}/${parts.slice(1).join("/")}`;
      } else if (firstSegment === "pt" && !ENABLE_PT) {
        targetPath = `/en/${parts.slice(1).join("/")}`;
      } else {
        targetPath = `/${lang}${location.pathname}`;
      }

      throw redirect({
        to: targetPath as any,
      });
    }
  },
  component: LangLayout,
});

function LangLayout() {
  const { lang } = Route.useParams();

  useEffect(() => {
    i18n.changeLanguage(lang);
    if (typeof window !== "undefined") {
      localStorage.setItem("bizu-lang", lang);
    }
  }, [lang]);

  return <Outlet />;
}
